import classNames from 'classnames'
import styled, {css, system, SystemProps, themeGetter} from 'quickstart/system'
import {ComponentProps} from 'react'

type TextContainerProps = ComponentProps<'div'> &
  SystemProps & {variant?: 'default' | 'wider'}

export const TextContainer = styled.div
  .attrs(({className}: TextContainerProps) => ({
    // Crutch for .customer-html
    className: classNames(className, 'text-container'),
  }))
  .attrs(
    ({variant}: TextContainerProps) =>
      variant && variant !== 'default' && {'data-variant': variant},
  )<TextContainerProps>(({theme, variant = 'default'}) => {
  const th = themeGetter(theme)
  return css`
    max-width: ${th(`textContainers.${variant}.maxWidths.xs`, null)};

    // Consume up to max-width in flex container. This allows positioning within
    // the site container to work consistently, regardless of content width.
    width: 100%;

    ${theme.bpKeys.map((bp: string) => {
      const minWidth = th(`breakpoints.${bp}`)
      const maxWidth = th(`textContainers.${variant}.maxWidths.${bp}`, null)
      return css`
        @media (min-width: ${minWidth}) {
          max-width: ${maxWidth};
        }
      `
    })};

    ${system};
  `
})
